import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { AppRouting } from '@core/enums';
import { DateFormatPipe } from '@core/pipes';
import { Substitutions, TranslatePipe } from '@selfcare/cms';
import { ButtonComponent, SvgComponent } from '@shared/components';
import dayjs from 'dayjs';

@Component({
  selector: 'sc-subscription-status',
  imports: [TranslatePipe, AsyncPipe, ButtonComponent, SvgComponent, DateFormatPipe, NgClass],
  templateUrl: './subscription-status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubscriptionStatusComponent {
  public isMarginLarge = input<boolean>(false);
  public contractEndDate = input<Date | null>(null);
  public isContractExpired = computed(() => dayjs().isAfter(this.contractEndDate()));

  public readonly Substitutions = Substitutions;
  public readonly AppRouting = AppRouting;
}
